import React, { Component } from 'react';
import lodashFilter from 'lodash/filter';
import lodashForEach from 'lodash/forEach';
import lodashMap from 'lodash/map';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';
import { Row, Col, Grid, Panel, Button } from 'react-bootstrap';
import { I18n, Translate } from 'react-redux-i18n';

import { RowRenderer } from '../../Common/rowRenderer';
import { APP_COLORS } from '../../Common/constants';
import { fetchGroupCategoriesWithCallback, fetchGroups, fetchProductsByParams } from '../../../actions/products_actions';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import ReactPaginate from 'react-paginate';
import { isVAK } from '../../../actions/root_url';
import Spinner from '../../Widgets/spinner';

const propTypes = {
  productCategoryId: PropTypes.number,
  previouslySelectedProducts: PropTypes.arrayOf(PropTypes.object),
  modifyConvertableProductList: PropTypes.func,
};

const defaultProps = {
  previouslySelectedProducts: [],
  modifyConvertableProductList: () => {},
};
const groupItemStyles = {
  margin: '10px 5px'
}
class BomProductsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupCategories: {},
      products: {
        rows: [],
        filters: null,
        sortColumn: null,
        sortDirection: null,
      },
      currentPage: 0,
      limit: 30,
      totalPages: 1,
      activeGroup: null,
      activeCategory: null,
      searchText: '',
    };
  }

  componentDidMount() {
    if (!this.props.groups || !this.props.groups.length) {
      this.props.fetchGroups();
    } else {
      const groupCategories = {};
      groupCategories[this.props.groups[0].ProductGroup_id] = this.props.groups[0].Categories;
      this.setState({
        activeGroup: this.props.groups[0].ProductGroup_id,
        groupCategories,
      });
    }
  }
  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.groups !== this.props.groups) {
      if (!this.state.activeGroup) {
        this.setState({
          activeGroup: nextProps.groups[0].ProductGroup_id,
        })
      }
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.state.activeGroup !== prevState.activeGroup || this.state.activeCategory !== prevState.activeCategory) {
      this.fetchProducts(0);
    }
  }

  fetchProducts = (page) => {
    const { previouslySelectedProducts, productCategoryId } = this.props;
    const handleSuccess = (response) => {
      let rows = response.data.products;
      let totalPages = response.data.pages;
      if (rows.length > 0 && previouslySelectedProducts.length > 0) {
        lodashForEach(previouslySelectedProducts, (prodToSelect) => {
          lodashMap(rows, (row) => {
            if (row.ProductNum === prodToSelect.ProductNum) {
              row.Selected = true;
            }
          });
        });
      }
      this.setState({
        isLoadingProductParts: false,
        products: {
          ...this.state.products,
          rows,
        },
        currentPage: page,
        totalPages,
      });
    }
    const handleFailure = () => {
      this.setState({
        isLoadingProductParts: false,
        products: {
          ...this.state.products,
          rows: [],
        },
        currentPage: 0,
        totalPages: 1,
      })
    }
    this.setState({ isLoadingProductParts: true }, () => {
      const params = {
        // Exclude_ProductGroup_id: productCategoryId,
      }
      if (this.state.searchText) {
        params.search = this.state.searchText;
      } else {
        if (this.state.activeCategory) {
          params.ProductCategory_id = this.state.activeCategory;
        } else {
          params.ProductGroup_id = this.state.activeGroup;
        }
      }
      params.page = page + 1;
      params.limit = this.state.limit;
      this.props.fetchProductsByParams(params, handleSuccess, handleFailure);
    });
  }

  selectExistingProduct = (product) => {
    const rows = JSON.parse(JSON.stringify(this.state.products.rows));
    const currentProduct = this.props.previouslySelectedProducts.length > 0 ? this.props.previouslySelectedProducts[0] : {ProductType: ''};
    if(product.ProductType == 'Fixed' && currentProduct.ProductType == 'Non-Fixed') {
      alert('Non fixed products cannot be converted to fixed products');
      return
    }
    lodashMap(rows, (row) => {
      if (row.ProductNum === product.ProductNum) {
        if (!row.Selected) {
          row.Selected = true;
        } else {
          row.Selected = false;
        }
      }
    });
    this.setState({
      products: {
        ...this.state.products,
        rows
      }
    });
    this.props.modifyConvertableProductList(product);
  }
  handleClickGroup(currentGroup) {
    const { groupCategories } = this.state;
    if(!groupCategories[currentGroup.ProductGroup_id]) {
      groupCategories[currentGroup.ProductGroup_id] = currentGroup.Categories;
    }
    this.setState({
      activeGroup: currentGroup.ProductGroup_id,
      activeCategory: null,
      groupCategories: {
        ...groupCategories,
      }
    })
  }
  handleClickChild(child) {
    this.setState({
      activeCategory: child.ProductCategory_id,
    })
  }
  renderGroups = () => {
    let groups = this.props.groups
    if(this.props.isCombination) {
      groups = groups.filter(item => item.GroupNum === '01' || item.GroupNum === '03' || item.GroupNum === '04' || item.GroupNum === '06' )
    }
    return groups.map((item) => {
      const checked = item.ProductGroup_id === this.state.activeGroup;
      return (
        <ul key={item.ProductGroup_id} style={groupItemStyles}>
          <div
            style={{ backgroundColor: checked ? APP_COLORS['active-category-background-nav']: null, fontFamily: 'Arial Black', cursor: 'pointer' }}
            name="group"
            id={item.ProductGroup_id}
            onClick = {()=>{this.handleClickGroup(item)}}
          >
            <label style={{ fontWeight: 'bold' }}>{item.Name}</label>
          </div>
          {checked && this.state.groupCategories[this.state.activeGroup] && this.renderChilds(this.state.groupCategories[this.state.activeGroup])}
        </ul>
      );
    })
  }
  renderChilds(childs) {
    return childs.map((childIt) => {
      const checked = childIt.ProductCategory_id === this.state.activeCategory;
      return <li key={childIt.ProductCategory_id} className="clickListLi" style={{ backgroundColor: checked ? APP_COLORS['active-category-background-nav']: null, fontFamily: 'Arial' }} name="category" id={childIt.ProductCategory_id} onClick = {()=>{this.handleClickChild(childIt)}}>
        <label style={{ fontWeight: 'bold' }}>{childIt.Name}</label>
      </li>
    })
  }

  renderProductsTable() {
    const getRows = () => Data.Selectors.getRows(this.state.products);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.products, { sortColumn, sortDirection });
      this.setState(state);
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.products.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({
        products: {
          ...this.state.products,
          filters: newFilters
        },
      });
    };

    const onClearFilters = () => {
      this.setState({
        products: {
          ...this.state.products,
          filters: {}
        }
      });
    };

    const CheckFormatter = React.createClass({
      render() {
        const { Selected } = this.props.dependentValues;
        if (Selected) {
          return <em className="fa fa-check" />;
        }
        return <div />;
      },
    });

    const handleOnPageChange = page => {
      this.fetchProducts(page.selected);
    }

    const columns = [
      {
        key: 'Selected',
        name: '',
        resizable: true,
        width: 25,
        filterable: true,
        formatter: <CheckFormatter />,
        getRowMetaData: row => row,
      },
      {
        key: 'ProductNum',
        name: <Translate value="prod_num" />,
        resizable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'RefNum',
        name: <Translate value={isVAK ? "sku" : "ref_num"} />,
        resizable: true,
        width: 100,
        filterable: true,
      },
      {
        key: 'Name',
        name: <Translate value="prod_name" />,
        resizable: true,
        width: 200,
        filterable: true,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        filterable: true,
        width: 200,
      },
      {
        key: 'PackageSize',
        name: <Translate value="package_size" />,
        resizable: true,
        filterable: true,
        width: 140,
      },
    ];

    return (
      <div>
        <Row>
          <Col sm={12}>
            <div style={{
              maxWidth: '100%',
              marginTop: '5px',
              position: 'relative'
            }}>
              <Col sm={6} style={{position: 'absolute'}}>
                <input
                  style={{
                    width: '150px',
                    margin: '5px 5px 5px 0px',
                    borderRadius: '5px',
                    padding: '2px',
                    border: '1px solid black',
                  }}
                  type="text"
                  onChange={e => {
                    this.setState({searchText: e.target.value})
                  }}
                  onKeyPress={e => {
                    if (e.charCode === 13) {
                      this.fetchProducts(0)
                    }
                  }}
                  value={this.state.searchText}
                  placeholder={I18n.t('product_num_sku')}
                />
                <Button bsStyle="primary" onClick={() => {
                  this.fetchProducts(0)
                }}>
                  <em className="fa fa-search" />
                </Button>
                {this.state.isLoadingProductParts && <Spinner style={{top: '-21px', left: '200px'}}/>}
              </Col>
              <ReactDataGrid
                rowRenderer={<RowRenderer onDoubleClick={this.selectExistingProduct}/>}
                rowKey="ProductNum"
                rowHeight={25}
                minHeight={420}
                onGridSort={handleGridSort}
                onAddFilter={handleFilterChange}
                onClearFilters={onClearFilters}
                columns={columns}
                toolbar={<Toolbar enableFilter/>}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                enableCellSelect
                minWidth={700}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <ReactPaginate
              previousLabel={<Translate value="prev_page"/>}
              nextLabel={<Translate value="next_page"/>}
              containerClassName={'pagination'}
              activeClassName={'active'}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              pageCount={this.state.totalPages}
              onPageChange={handleOnPageChange}
              forcePage={this.state.currentPage}
            />
          </Col>
        </Row>
      </div>
    );
  }
  render() {
    return (
      <Grid id="bom-products">
        <Row>
          <Col xs={2}>
            {this.renderGroups()}
          </Col>
          <Col xs={10}>
            {this.renderProductsTable()}
          </Col>
        </Row>
      </Grid>
    )
  }
}

BomProductsModal.propTypes = propTypes;
BomProductsModal.defaultProps = defaultProps;
const mapStateToProps = state => {
  return {
    groups: (state.products.groups || []),
  }
}
const mapDispatchToProps = {
  fetchProductsByParams,
  fetchGroups,
}
export default connect(mapStateToProps, mapDispatchToProps)(BomProductsModal);



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/BomProductsModal.jsx